import { useEffect, useRef } from "react";
import { initializeAnalytics } from "src/services/analyticsInit";

/**
 * Hook to initialize analytics with proper inhouse_anonymous_id
 * Should be called early in the App component to ensure the ID is ready
 * before any analytics events are fired
 */
export const useAnalyticsInit = () => {
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;
    initializeAnalytics();
  }, []);
};

export default useAnalyticsInit;
